import React from 'react'
import { uniq } from 'lodash'
import styled from 'styled-components'
import teamManager from '../teamManager.js'

const Wrapper = styled.div`
    position: absolute;
    top: 15px;
    left: 15px;
    text-align: center;
    display: flex;
    font-family: 'Teko';
    font-weight: 300;
    font-size: 2.5rem;
    line-height: 2.5rem;
    padding: 0.2rem;
    opacity: 0.8;
    text-transform: uppercase;
    user-select: none;
    pointer-events: none;
`

const AliveCountWrapper = styled.div`
    display: flex;
    flex-direction: row;
`

const AliveCountNumber = styled.div`
    color: #FFFFFF;
    background-color: #ff3461;
    padding: 0.5rem 0.5rem 0;
`

const AliveText = styled.div`
    color: #CCCCCC;
    background-color: #100c1e;
    padding: 0.5rem 0.5rem 0;
`

const AliveTeamsCountWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: 0.5rem;
`

const AliveTeamsCountNumber = styled.div`
    color: #FFFFFF;
    background-color: #ff3461;
    padding: 0.5rem 0.5rem 0;
`

const AliveTeamsText = styled.div`
    color: #CCCCCC;
    background-color: #100c1e;
    padding: 0.5rem 0.5rem 0;
`

const AliveCount = ({ players }) => {
    if (!players) {
        return null
    }

    const alivePlayers = Object.values(players).filter(p => p.status !== 'dead' && p.health > 0)
    const aliveCount = alivePlayers.length
    const aliveTeams = uniq(alivePlayers.map(p => p.teamId !== undefined ? p.teamId : teamManager.getTeamId(p.name))).length

    return (
        <Wrapper>
            <AliveCountWrapper>
                <AliveCountNumber>{aliveCount}</AliveCountNumber>
                <AliveText>alive</AliveText>
            </AliveCountWrapper>

            <AliveTeamsCountWrapper>
                <AliveTeamsCountNumber>{aliveTeams}</AliveTeamsCountNumber>
                <AliveTeamsText>teams</AliveTeamsText>
            </AliveTeamsCountWrapper>
        </Wrapper>
    )
}

export default AliveCount



// WEBPACK FOOTER //
// src/components/MatchPlayer/Map/AliveCount.js